<template>
    <div class="over-view" v-show="show">
        <a :href="`${host}/news/detail43`">胜诉！南京药育知识产权维权取得成功！</a>
        <a href="" @click.prevent="show = false"><i class="el-icon el-icon-circle-close"></i></a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true,
            host: 'http://' + window.location.host
        }
    }
}
</script>

<style lang="scss" scoped>
.over-view {
    width: 100%;
    height: 70px;
    position: fixed;
    background-image: linear-gradient(90deg, transparent 1%, 
                        rgba(red, 0.5) 15%, 
                        rgba(red, 0.9) 40%, 
                        rgba(red, 0.9) 60%, 
                        rgba(red, 0.7) 90%, 
                        transparent 100%);
    color: #fff;
    line-height: 70px;
    text-align: center;
    box-shadow: 0 15px 10px rgba($color: #000000, $alpha: 0.1);
    font-size: 30px;
    bottom: 0;
    z-index: 99999;
    a{
        &:nth-child(2) {
            position: absolute;
            top: -10px;
            margin-left: 75px;
            font-size: 24px;
        }
    }
}
</style>
